// src/helpers/searchAnalytics.ts

export interface SearchFunnelSegment {
  name: string;
  searches: number;
  searchesWithOpen: number;
  opens: number;
  outbounds: number;
  uniqueSearchers: number;
  searchToOpenRate: number;
  openToOutboundRate: number;
  searchToOutboundRate: number;
}

export interface FunnelTotals {
  searches: number;
  searchesWithOpen: number;
  opens: number;
  outbounds: number;
  uniqueSearchers: number;
  searchToOpenRate: number;
  openToOutboundRate: number;
  searchToOutboundRate: number;
}

export const formatRate = (rate: number): string => `${(rate * 100).toFixed(1)}%`;

const safeDivide = (numerator: number, denominator: number): number =>
  denominator === 0 ? 0 : numerator / denominator;

export const sumSegmentsToTotals = (
  segments: SearchFunnelSegment[]
): FunnelTotals => {
  const sum = segments.reduce(
    (acc, s) => {
      acc.searches += s.searches;
      acc.searchesWithOpen += s.searchesWithOpen;
      acc.opens += s.opens;
      acc.outbounds += s.outbounds;
      acc.uniqueSearchers += s.uniqueSearchers;
      acc.searchesWithOutbound += Math.round(s.searchToOutboundRate * s.searches);
      return acc;
    },
    {
      searches: 0,
      searchesWithOpen: 0,
      opens: 0,
      outbounds: 0,
      uniqueSearchers: 0,
      searchesWithOutbound: 0,
    }
  );

  return {
    searches: sum.searches,
    searchesWithOpen: sum.searchesWithOpen,
    opens: sum.opens,
    outbounds: sum.outbounds,
    uniqueSearchers: sum.uniqueSearchers,
    searchToOpenRate: safeDivide(sum.searchesWithOpen, sum.searches),
    openToOutboundRate: safeDivide(sum.outbounds, sum.opens),
    searchToOutboundRate: safeDivide(sum.searchesWithOutbound, sum.searches),
  };
};

export const segmentLabel = (name: string): string =>
  name === "unknown" ? "Unknown" : name;

export const queryLabel = (row: {
  query: string;
  displayQuery: string | null;
}): string => row.displayQuery ?? row.query;
